<div class="app-loader">
  <span>
    <i class="fa fa-refresh fa-spin fa-5x"></i>
  </span>
</div>
